import { html, View } from 'rune-ts';
import klass from './ShopView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';
import { IconsBasicArrowChevronRightIcon } from '@services/MarppleShop/shared/components/atoms/Icon';
import { makeUtilScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { pipe } from '@fxts/core';
import { CreatorConstantS } from '@services/MarppleShop/features/Creator/outbound/share.ts';
import { CountViewView } from '@services/MarppleShop/renderApp/pages/Curation/components/CountViewView.ts';
import { CardProductError } from '@services/MarppleShop/renderApp/pages/Curation/components/CardProductView.ts';

export type TProps =
  | {
      type: 'Text';
      theme: 'Light';
      size: '11px';
      store_name: string;
      domain_name: string;
    }
  | {
      type: 'Text';
      theme: 'Light';
      size: '12px';
      store_name: string;
      domain_name: string;
    }
  | {
      type: 'Text';
      theme: 'Light';
      size: '13px';
      store_name: string;
      domain_name: string;
    }
  | {
      type: 'Box';
      theme: 'Light';
      size: '11px';
      store_name: string;
      domain_name: string;
      profile_image_url: string | null;
    }
  | {
      type: 'Box';
      theme: 'Dark';
      size: '11px';
      store_name: string;
      domain_name: string;
      profile_image_url: string | null;
    }
  | {
      type: 'Box';
      theme: 'Light';
      size: '13px';
      store_name: string;
      domain_name: string;
      profile_image_url: string | null;
      watcher_count: number;
    }
  | {
      type: 'Box';
      theme: 'Dark';
      size: '13px';
      store_name: string;
      domain_name: string;
      profile_image_url: string | null;
      watcher_count: number;
    }
  | {
      type: 'Line';
      theme: 'Light';
      size: '11px';
      store_name: string;
      domain_name: string;
      profile_image_url: string | null;
    }
  | {
      type: 'Line';
      theme: 'Light';
      size: '13px';
      store_name: string;
      domain_name: string;
      profile_image_url: string | null;
      watcher_count: number;
    };

/**
 * https://www.figma.com/design/J3pxvmlv167DXuLToyL3Mg/%EC%83%81%ED%92%88-%EC%B9%B4%EB%93%9C-UI?node-id=368-190612&m=dev
 */
export class ShopView extends View<TProps> {
  protected override template(props: TProps) {
    const href = `/${T.lang}/${props.domain_name}`;

    const data_post_message = pipe(href, makeUtilScreenNavigate, dataStr);

    if (props.type === 'Text' && props.theme === 'Light' && props.size === '11px') {
      const { store_name } = props;

      return html`<a
        class="${classes(klass.shop_type_text, font('11_semibold'))}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        ${html.preventEscape(store_name)}
      </a>`;
    } else if (props.type === 'Text' && props.theme === 'Light' && props.size === '12px') {
      const { store_name } = props;

      return html`<a
        class="${classes(klass.shop_type_text, font('12_semibold'))}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        ${html.preventEscape(store_name)}
      </a>`;
    } else if (props.type === 'Text' && props.theme === 'Light' && props.size === '13px') {
      const { store_name } = props;

      return html`<a
        class="${classes(klass.shop_type_text, font('13_semibold'))}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        ${html.preventEscape(store_name)}
      </a>`;
    } else if (props.type === 'Box' && props.theme === 'Light' && props.size === '11px') {
      const { store_name, profile_image_url } = props;

      return html`<a
        class="${classes(klass.shop_type_box, klass.size_11px, klass.theme_light)}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        <img
          alt=""
          src="${profile_image_url ?? CreatorConstantS.default_creator_img}"
          class="${classes(klass.profile, klass.size_11px)}"
        />

        <p
          class="${classes(
            klass.creator_shop_name_text,
            klass.size_11px,
            klass.theme_light,
            font('11_medium'),
          )}"
        >
          ${html.preventEscape(store_name)}
        </p>
      </a>`;
    } else if (props.type === 'Box' && props.theme === 'Dark' && props.size === '11px') {
      const { store_name, profile_image_url } = props;

      return html`<a
        class="${classes(klass.shop_type_box, klass.size_11px, klass.theme_dark)}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        <img
          alt=""
          src="${profile_image_url ?? CreatorConstantS.default_creator_img}"
          class="${classes(klass.profile, klass.size_11px)}"
        />

        <p
          class="${classes(
            klass.creator_shop_name_text,
            klass.size_11px,
            klass.theme_dark,
            font('11_medium'),
          )}"
        >
          ${html.preventEscape(store_name)}
        </p>
      </a>`;
    } else if (props.type === 'Box' && props.theme === 'Light' && props.size === '13px') {
      const { store_name, profile_image_url, watcher_count } = props;

      return html`<a
        class="${classes(klass.shop_type_box, klass.size_13px, klass.theme_light)}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        <img
          alt=""
          src="${profile_image_url ?? CreatorConstantS.default_creator_img}"
          class="${classes(klass.profile, klass.size_13px)}"
        />

        <div class="${klass.creator_shop_name_wrapper}">
          <span
            class="${classes(
              klass.creator_shop_name_text,
              klass.size_13px,
              klass.theme_light,
              font('13_medium'),
            )}"
            >${html.preventEscape(store_name)}</span
          >

          <div class="${classes(klass.icons_basic, klass.theme_light)}">
            ${IconsBasicArrowChevronRightIcon}
          </div>
        </div>

        <span class="${classes(klass.count_view, klass.theme_light, font('12_medium'))}">
          ${ET('card_product::shop::watching', { watcher_count })}
        </span>
      </a>`;
    } else if (props.type === 'Box' && props.theme === 'Dark' && props.size === '13px') {
      const { store_name, profile_image_url, watcher_count } = props;

      return html`<a
        class="${classes(klass.shop_type_box, klass.size_13px, klass.theme_dark)}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        <img
          alt=""
          src="${profile_image_url ?? CreatorConstantS.default_creator_img}"
          class="${classes(klass.profile, klass.size_13px)}"
        />

        <div class="${klass.creator_shop_name_wrapper}">
          <span
            class="${classes(
              klass.creator_shop_name_text,
              klass.size_13px,
              klass.theme_dark,
              font('13_medium'),
            )}"
            >${html.preventEscape(store_name)}</span
          >

          <div class="${classes(klass.icons_basic, klass.theme_dark)}">
            ${IconsBasicArrowChevronRightIcon}
          </div>
        </div>

        <span class="${classes(klass.count_view, klass.theme_dark, font('12_medium'))}"
          >${ET('card_product::shop::watching', { watcher_count })}</span
        >
      </a>`;
    } else if (props.type === 'Line' && props.theme === 'Light' && props.size === '11px') {
      const { store_name, profile_image_url } = props;

      return html`<a
        class="${klass.shop_type_line_size_11px}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        <img
          alt=""
          src="${profile_image_url ?? CreatorConstantS.default_creator_img}"
          class="${classes(klass.profile, klass.size_13px)}"
        />

        <span class="${classes(klass.creator_shop_name_text, font('12_medium'))}"
          >${html.preventEscape(store_name)}</span
        >
      </a>`;
    } else if (props.type === 'Line' && props.theme === 'Light' && props.size === '13px') {
      const { store_name, profile_image_url, watcher_count } = props;

      return html`
        <a class="${klass.shop_type_line_size_13px}" href="${href}" data-post-message="${data_post_message}">
          <img
            alt=""
            src="${profile_image_url ?? CreatorConstantS.default_creator_img}"
            class="${classes(klass.profile, klass.size_13px)}"
          />

          <span class="${classes(klass.creator_shop_name_text, font('12_medium'))}"
            >${html.preventEscape(store_name)}</span
          >

          <span class="${klass.count_view_wrapper}"
            >${new CountViewView({ size: 'Medium', watcher_count })}</span
          >
        </a>
      `;
    } else {
      throw new CardProductError();
    }
  }
}
